import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { AuthProvider } from './pages/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    
    <BrowserRouter>
<ThemeProvider>
  <AuthProvider>
      <ThemeProvider>

    <App/>
</ThemeProvider>
  </AuthProvider>
</ThemeProvider>
</BrowserRouter>
  </React.StrictMode>
);
